import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Blade hunter",
  "description": "",
  "published": "2007-07-20T00:00:00.000Z",
  "redirect_from": ["/blog/blade-hunter/swizec/170"],
  "categories": "funny",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few nights ago I heard strange noises in the dark and was almost mildly scared by them, but I did not freat, I quietly hid under my bed and waited for them to pass wondering what was the cause of the mystery and scary events.`}</p>
    <p>{`Then some time later when the lights were on I came upon an interesting sight and suddenly realised what the cause of scary sounds in the night was ... a brave kitty hunting down spinning blades on my `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=news/id=232"
      }}>{`Heat Deterrant System`}</a>{`.`}</p>
    <p>{`Haha, youtube made it darker ... too bad.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      